export const signInUserConfig = {
  signInEP: '/user/sign-in',
  signInTypeEP: '/user/sign-in-type/get',
  sendOTPEP: '/otp/send',
  setPassword: '/password/set',
  sendVerifyOTP: '/email/verify-by-otp',
  validateEmail: '/email/exist',
  accessTokenEP: '/user/access-token/get',
};
